"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LagTimer = exports.LagRecorder = void 0;
class LagRecorder {
    constructor(max = 16) {
        this.readings = [];
        this.max = max;
    }
    record(v) {
        this.readings.unshift(v);
        while (this.readings.length > this.max) {
            this.readings.pop();
        }
    }
    read(count) {
        let sum = 0;
        for (let i = 0; i < count; i++) {
            sum += this.readings[i];
        }
        return Math.round(sum / count);
    }
    observe() {
        const readings = {
            size: this.readings.length,
        };
        for (let i = 1; i <= this.max; i = 2 * i) {
            readings[i] = this.read(i);
        }
        return readings;
    }
}
exports.LagRecorder = LagRecorder;
class LagTimer extends LagRecorder {
    constructor() {
        super(...arguments);
        this._starts = [];
        this.lastStart = 0;
        this.lastStop = 0;
    }
    start() {
        const now = Date.now();
        this._starts.push(now);
        this.lastStart = now;
        return this;
    }
    advance() {
        const start = this._starts.shift();
        if (!start) {
            return this;
        }
        const now = Date.now();
        this.record(now - start);
        this.lastStop = now;
        return this;
    }
    observe() {
        return Object.assign(super.observe(), {
            lastStart: this.lastStart,
            lastStop: this.lastStop,
        });
    }
}
exports.LagTimer = LagTimer;
//# sourceMappingURL=LagRecorder.js.map